import {
  CollectionContext
} from "../__chunks/T3DJZG63.js";
import {
  createComponent,
  createElement,
  createHook
} from "../__chunks/NQJBHION.js";
import {
  useWrapElement
} from "../__chunks/J7Q2EO23.js";
import "../__chunks/CP3U4HPL.js";
import {
  __objRest
} from "../__chunks/PNRLI7OV.js";

// src/collection/collection.tsx
import { jsx } from "react/jsx-runtime";
var useCollection = createHook(
  (_a) => {
    var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
    props = useWrapElement(
      props,
      (element) => /* @__PURE__ */ jsx(CollectionContext.Provider, { value: store, children: element }),
      [store]
    );
    return props;
  }
);
var Collection = createComponent((props) => {
  const htmlProps = useCollection(props);
  return createElement("div", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  Collection.displayName = "Collection";
}
export {
  Collection,
  useCollection
};
